import ApiService from '@/common/api/api.service';

let apiBasePath = 'DisciplinaCurriculo';

const DisciplinaCurriculo = {
  // FUNÇÕES CRUD:
  async criar(form) {
    const payload = {
      descricao: form.descricao,
      vinculavelDisciplinaInterna: form.vinculavelDisciplinaInterna,
      disciplinasId: form.disciplinas.map((i) => i.id),
    };
    let { data } = await ApiService.post(`${apiBasePath}`, payload);
    return data;
  },
  async editar(form) {
    const payload = {
      descricao: form.descricao,
      id: form.id,
      vinculavelDisciplinaInterna: form.vinculavelDisciplinaInterna,
    };

    let { data } = await ApiService.put(`${apiBasePath}`, payload);
    return data;
  },
  async excluir(disciplinaId) {
    let { data } = await ApiService.delete(`${apiBasePath}/${disciplinaId}`);
    return data;
  },
  // FUNÇÕES DE VINCULAR DISCIPLINA CEJ COM DISCIPLINA INSTITUIÇÃO
  async vincular(form) {
    let { data } = await ApiService.post(
      `${apiBasePath}/disciplina/adicionar`,
      form
    );
    return data;
  },
  async removerDisciplina(id) {
    let { data } = await ApiService.delete(
      `${apiBasePath}/remover/DisciplinaCurriculo/${id}`
    );
    return data;
  },
  async desvincular(form) {
    let { data } = await ApiService.delete(
      `${apiBasePath}/disciplina/remover?DisciplinaCurriculoId=${form.disciplinaCurriculoId}&DisciplinaInternaId=${form.disciplinaInternaId}`
    );
    return data;
  },
  // FUNÇÕES DE OBTENÇÃO DE DADOS:
  async obterPorId(disciplinaId) {
    let { data } = await ApiService.get(`${apiBasePath}/${disciplinaId}`);
    return data;
  },
  async obterDisciplinasCurriculoEscolar() {
    let { data } = await ApiService.get(
      `${apiBasePath}/obter-disciplinas-por-filtro?OrdenacaoAscendente=false&TamanhoDaPagina=10000`
    );
    return data.data.itens.map((disciplina) => ({
      ...disciplina,
      text: disciplina.descricao,
      value: disciplina.id,
    }));
  },
  async obterPorFiltro(filtro, paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(
      `${apiBasePath}/obter-disciplinas-por-filtro`,
      {
        params: {
          Expressao: filtro,
          ...paginacao,
          CampoOrdenado: campoOrdenado,
          OrdenacaoAscendente: ordem,
        },
      }
    );
    return data;
  },
  async obterTodas(paginacao, campoOrdenado, ordem) {
    let { data } = await ApiService.get(`${apiBasePath}/obter-por-filtro`, {
      params: {
        TamanhoDaPagina: paginacao.tamanhoDaPagina,
        NumeroDaPagina: paginacao.numeroDaPagina,
        CampoOrdenado: campoOrdenado,
        OrdenacaoAscendente: ordem,
      },
    });
    return data;
  },
  async listaVinculavelDisciplinaInterna() {
    let { data } = await ApiService.get(
      `${apiBasePath}/lista-vinculavel-disciplina-interna`
    );
    return data;
  },
    async obterTodasDisciplinas() {
      const { data } = await ApiService.get(`Disciplina`);
  
      return data?.data ?? data;
    },
};

export default DisciplinaCurriculo;
